

























/* api */
import GetImageApi from '@/app/model/api/getImageApi'
import GetMachineImgApi from '@/app/model/api/getMachineImgApi'
/* module */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component
export default class FieldImg extends Vue {
  private noImgPath: string = require('@/assets/img/no_image.svg')
  private originalImagePath: string = ''
  private displayImg: string = ''
  private showImgLoading: boolean = true

  @Prop() private machineId!: number
  @Prop() private imgPath!: any

  @Watch('imgPath')
  onChangeImgData (data: any) {
    this.getDefaultImg()
  }

  created () {
    this.getDefaultImg()
  }

  private async getDefaultImg () {
    if (this.imgPath !== null && this.imgPath !== '') {
      const result = await GetMachineImgApi.getMachineImgData(String(this.machineId))
      // resultがオブジェクト型の場合、エラーで画像が存在しないため「登録なし」を表示
      if (typeof result === 'object') {
        this.displayImg = require('@/assets/img/no_image.svg')
      } else {
        this.displayImg = String(result)
      }
    } else {
      this.displayImg = require('@/assets/img/no_image.svg')
    }
    this.showImgLoading = false
  }
}
